import React from 'react';

import Breadcumb from './Breadcumb';
import Steps from './Steps';
import CallToaction from './CallToaction';

function Main() {
  return (
    <>
      <Breadcumb />
      <Steps />
      <CallToaction />
    </>
  );
}

export default Main;
